const data = {
  pageName: "CheckoutOnboarding",
  services: {
    translations: {
      url: "onboarding/translations",
      params: {}
    },
    initialData: {
      url: "onboarding/initialData",
      params: {}
    },
    basketData: {
      url: "onboarding/basketData",
      params: {}
    },
    liveness: {
      url: "liveness/translations",
      params: { prefix: "r.liveness.*", removePrefix: "liveness." }
    },
    document: {
      url: "onboarding/document",
      params: {}
    },
    donorDocument: {
      url: "onboarding/donorDocument",
      params: {}
    },
    checkClickToCallRequest: {
      url: "onboarding/checkClickToCallRequest",
      params: {}
    },
    checkClickToCallAvailability: {
      url: "onboarding/checkClickToCallAvailability"
    },
    fetchCheckoutOnboarding: {
      url: "onboarding/fetchCheckoutOnboarding",
      params: {}
    },
    getGenericAppConfigs: {
      url: "onboarding/getGenericAppConfigs",
      params: {}
    },
    getPrepayAvailableMsisdns: {
      url: "onboarding/getPrepayAvailableMsisdns",
      params: {}
    },
    getPrepayDonors: {
      url: "onboarding/getPrepayDonors",
      params: {}
    },
    individual: {
      url: "onboarding/individual",
      params: {}
    },
    getCountries: {
      url: "onboarding/getCountries",
      params: {}
    },
    getBirthAreas: {
      url: "onboarding/getBirthAreas",
      params: {}
    },
    getProfession: {
      url: "onboarding/getProfession",
      params: {}
    },
    getAvailableTaxOffices: {
      url: "onboarding/getAvailableTaxOffices",
      params: {}
    },
    getGeographicAddress: {
      url: "geographicAddress",
      params: {}
    },
    termsOfService: {
      url: "onboarding/termsOfService",
      params: {}
    },
    checkoutThankYou: {
      url: "onboarding/checkoutThankYou",
      params: {}
    },
    updateCustomerOnboarding: {
      url: "onboarding/updateCustomerOnboarding",
      params: {}
    },
    checkoutThankYouIndividual: {
      url: "onboarding/checkoutThankYouIndividual",
      params: {}
    }
  },
  declarationImg:
    "https://www.vodafone.gr/images/d1490709395943-sim-pack-TRANSLATION.jpg"
};

exports.data = data;
